import CreateUserForm from '../CreateUserForm/CreateUserForm'
import './NewUser.css'

export default function NewUser({user, updateUsers, toggleNotifications}) {
  return (
    <div className='NewUser modal fade' id='newUserModal' data-bs-backdrop="static" data-bs-keyboard="true" aria-labelledby={`newUserHeader`}>
        <CreateUserForm user={user} updateUsers={updateUsers} toggleNotifications={toggleNotifications} />
    </div>
  )
}
